import { Panel } from '../panel.class';
import { PanelConnectionType } from '../enums';
import { Panels } from '../panels.class';

export const buildStandardIslandPanelsCfn = (panels: Panels): string => {
	// console.log('buildStandardIslandPanels');
	const frontPanel = new Panel({ parent: panels, dataIn: { label: 'front' }});
	const backPanel = new Panel({ parent: panels, dataIn: { label: 'back' }});
	const leftPanel = new Panel({ parent: panels, dataIn: { label: 'left' }});
	const rightPanel = new Panel({ parent: panels, dataIn: { label: 'right' }});

	frontPanel.connectLeftSideToPanel(leftPanel, PanelConnectionType.Inside, 90);
	leftPanel.connectLeftSideToPanel(backPanel, PanelConnectionType.Outside, 90);
	backPanel.connectLeftSideToPanel(rightPanel, PanelConnectionType.Inside, 90);
	rightPanel.connectLeftSideToPanel(frontPanel, PanelConnectionType.Outside, 90);

	panels.children.push(frontPanel, leftPanel, backPanel, rightPanel);
	return frontPanel.id;
};
